/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 视频
 */
'use strict';
angular.module("videoModule", ['videoRouterModule', 'videoDetailModule']).
controller('videoCtrl', ['$scope', '$element', '$stateParams', '$q', '$compile', '$state', 'httpService', 'modalDialog', 'ueditorService', '$validation', 'localStorageService', '$timeout', '$sce', '$interval', "playVideoService", "editPictureService", function($scope, $element, $stateParams, $q, $compile, $state, httpService, modalDialog, ueditorService, $validation, localStorageService, $timeout, $sce, $interval, playVideoService, editPictureService) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.srcVideo = '';
        $scope.status = {
            videoIds: [], //视屏数据的集合
            progress: '0', //上传进度
            libType_v:101,//video的libType
            uploadSuccess: false, //视频是否上传成功
            uploadError: false, //视频是否上传失败
            transcoding: false, //视频正在转码
            transcodSuccess: false, //视屏是否转码成功
            transcodError: false, //视频是否转码失败
            videoUrl: '', //视屏的播放地址
            videoImageUrl: '', //视频播放图片的地址
            isBackstage: false, //区分后台和前台
            timer: null,
        }
        $scope.data = {}
        loadUploadIframe();
    };

    function initData() {
        getPubWayInfo().then(function() {
            return initList();
        }).then(function() {
            loadUeditor();
        });
    };

    /**
     * [uploadVideo description]初始化上传至吉木萨尔县在线的视频的方法
     * @return {[type]} [description]
     */
    $scope.uploadVideo = function() {
        // document.getElementById("videoUpload").click();
        uploadVideo();
    };

    function uploadVideo() {
        // debugger;
        document.getElementById("videoUpload").contentWindow.postMessage('upload', "/");
        // document.getElementById("videoUpload").contentWindow.postMessage('upload', "");
        videoeventListener(); //视频启动监听
    }
    /**
     * [videoeventListener description] postMessage视频信息监听
     * @return {[type]} [description]
     */
    function videoeventListener() {
        clearVideoEventListener(); //先清除
        $scope.status.uploadBoxShow = false;
        window.addEventListener('message', videotheEvent, true);
    }
    /**
     * [clearVideoEventListener description] 清除视频监听服务
     * @return {[type]} [description]
     */
    function clearVideoEventListener() {
        if (angular.isFunction(videotheEvent)) {
            window.removeEventListener("message", videotheEvent, false);
        }
    }
    /**
     * [videotheEvent description] 视频监听事件方法
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    function videotheEvent(e) {
        console.log(e);
        if (!!e && angular.isString(e.data) && e.data.indexOf('video') > -1) {
            var msg = e.data;
            //判断是否是正确格式
            if (msg.indexOf("progress") > -1) {
                $timeout(function() {
                    $scope.status.progress = e.data.split("=")[1];
                });
            } else if (msg.indexOf("complete") > -1) {
                $scope.status.uploadSuccess = true;
                var vId = e.data.split("=")[1]; //获得视屏id
                $scope.status.videoIds.push({
                    'id': vId
                });
                // debugger;
                $scope.status.transcoding = true; //先显示视屏正在转码
                saveVideo(vId).then(function(data) {
          
                    if (data.code == 0) {
                        videotimer(vId); //循环查询视屏有没有转码成功
                        getVideoImage(vId); //获取视频的播放图片
                    }
                })
                //视屏上传完之后 先查询稿件的转码信息


            } else if (msg.indexOf("type") > -1) {
                modalDialog.alertType("上传失败", "请选择正确的视频格式，再上传！", "warning", "confirm", function() {
                    $scope.deletevideo();
                });
                return;
            }
        }
    }
    $scope.deletevideo = function() {
        document.getElementById("videoUpload").src = document.getElementById("videoUpload").src;
        document.getElementById("videoUpload").contentWindow.postMessage('delete', "/");
        $interval.cancel($scope.status.timer);
        clearVideoEventListener(); //清除视频监听
        $scope.status.progress = '0'; //上传进度清零
        $scope.status.uploadSuccess = false; //视频是否上传成功
        $scope.status.uploadError = false; //视频是否上传失败
        $scope.status.transcoding = false; //视频正在转码
        $scope.status.transcodSuccess = false; //视屏是否转码成功
        $scope.status.transcodError = false; //视频是否转码失败
        $scope.status.videoUrl = ''; //视屏的播放地址
        $scope.status.videoImageUrl = ''; //清空上传的视频的预览图
        $scope.status.videoIds.length = 0; //清空上传的视屏的id
    }
    /**
     * [openVideo description] 打开视频播放
     * @return {[type]} [description]
     */
    $scope.playVideo = function() {
        if (!$scope.status.transcodSuccess) {
            modalDialog.alertType("", "视频正在处理中，请等待处理结束", "warning", "confirm");
            return;
        } else {
            // var v = $element.find("video")[0];
            // if (v.paused) {
            //     v.play();
            // } else {
            //     v.pause();
            // }
        }
    }
    /**
     * [saveVideo description] 保存音视屏
     * @param  {[type]} dataId [description]
     * @return {[type]}        [description]
     */
    function saveVideo(vId) {
        var deffer = $q.defer();
        httpService.http("/mcnww/web/cloud/saveVideo.do", { id: vId, libType: $scope.status.libType_v }, "get").then(function(data) {
            // debugger;
            deffer.resolve(data);
        });
        return deffer.promise;
    }
    /**
     * [videotimer description] 查询视频转码状态
     * @param  {[type]} dataId [description]
     * @return {[type]}        [description]
     */
    function videotimer(vId) {
        $scope.status.timer = $interval(function() {
            var params = {
                id: vId,
                libType: $scope.status.libType_v
            }
            httpService.http("/mcnww/web/cloud/getVideoStatus.do", params, "get", "", true).then(function(data) {
                if (data.code === 0) {
                    if (data.data.code === 0) {
                        // $scope.status.transcoding = false; //先显示视屏正在转码
                        $interval.cancel($scope.status.timer);
                        $scope.status.transcoding = false;
                        $scope.status.transcodSuccess = true;
                        getVideoUrl(vId);
                    }
                }
            });
        }, 3000);
    }
    //获取播放视频的图片
    function getVideoImage(vId) {
        httpService.http("/mcnww/web/cloud/getMediaFrame.do", { id: vId,libType:201 }, "get").then(function(data) {
            $scope.status.videoImageUrl = data.data.mediaFrameUrl;
        });
    }
    //获取播放视频的地址
    function getVideoUrl(vId) {
        httpService.http("/mcnww/web/cloud/getVideoUrl.do", { id: vId, libType: $scope.status.libType_v }, "get").then(function(data) {
            if (data.data.videoUrl) {
            	// debugger;
                $scope.status.videoUrl = $sce.trustAsResourceUrl(data.data.videoUrl);
                
            }
        });
    }
    /**
     * [loadUploadIframe description] 加载上传视频的iframe
     * @return {[type]} [description]
     */
    function loadUploadIframe() {
        $.ajax({
            url: "/mcnww/web/cloud/videoUpload.do",
            type: 'post',
            headers:{requestToken:sessionStorage.getItem('requestToken')},
            data: "",
            datatype: 'text',
            success: function(data) {
                var urlarr = data.split("/");
                urlarr.splice(0,3);
                $scope.srcVideo="/"+urlarr.join("/");
                // data = data.replace(/http:\/\/testqiniu.tmuyun.com:8080/, "");
                // $scope.srcVideo = data;
                // // $scope.status.uploadVideoUrl = data;
                // $scope.srcVideo = $sce.trustAsResourceUrl(data);
            }
        });
    }
    /*
     * 文章数据
     */
    $scope.list = {
        id: 0,
        articleTitle: "",
        articleChannel: 0,
        articleHtmlCon: '',
        articleStatus: ""
    };
    /**
     * [initList description] 初始化表单数据
     * @return {[type]} [description]
     */
    function initList() {
        var deffer = $q.defer();
        if (!!$stateParams.id) {
            $scope.status.progress = '100';
            $scope.status.transcodSuccess = true;
            $scope.status.uploadSuccess = true;
            getDraftInfo().then(function(result) {
                for (var i in $scope.list) {
                    $scope.list[i] = result.articeInfo[i];
                }
                $scope.status.videoIds = JSON.parse(result.articeInfo.videos);
                getVideoImage($scope.status.videoIds[0].id);  //获取vedeo播放地址的图片，先注释掉
                getVideoUrl($scope.status.videoIds[0].id);
                $scope.selectedChannel = result.chnlsAndTags;
                $scope.$broadcast('selectedChannel', $scope.selectedChannel);
                deffer.resolve();
            });
        } else {
            deffer.resolve();
        }
        return deffer.promise;
    }
    /**
     * [getDraftInfo description] 查询稿件信息
     * @return {[type]} [description]
     */
    function getDraftInfo() {
        var deffer = $q.defer();
        var params = {
            articleId: $stateParams.id
        };
        httpService.http("/mcnww/web/pgcArticle/findById.do", params, "get").then(function(result) {
            deffer.resolve(result);
        });
        return deffer.promise;
    }
    /**
     * [loadUeditor description] 加载编辑器
     * @return {[type]} [description]
     */
    function loadUeditor() {
        var $ueditor = $("<ueditor></ueditor>");
        var $ueditorLocation = $element.find("ueditorLocation");
        LazyLoad.js(["./static/ueditor/ueditor.config.js?v=11.4", "./static/ueditor/ueditor.all.js?v=11.4"], function() {
            $ueditor.attr({
                type: 'video',
                list: "list",
                "has-content": "status.hasContent",
                versionid: $scope.list.id,
                infullscreen: "status.infullscreen",
                placeholder: "请输入文章正文"
            });
            $ueditor = $compile($ueditor)($scope);
            $ueditorLocation.append($ueditor);
        });
    }
    /**
     * [save description] 保存或发布文章
     * @return {[type]} [description]
     */
    $scope.save = function(ispub) {
        saveContent().then(function() {
            return validator();
        }).then(function() {
            saveArticle(ispub);
        })
    };
    /**
     * [saveArticle description] 保存文章
     * @return {[type]} [description]
     */
    function saveArticle(ispub) {
        if (!$scope.status.uploadSuccess) {
            modalDialog.alertType("", "视频正在上传中，请等待上传结束", "warning", "confirm");
            return;
        }
        if (!$scope.status.transcodSuccess) {
            modalDialog.alertType("", "视频正在处理中，请等待处理结束", "warning", "confirm");
            return;
        }
        var channelData = getSelectChannel();
        if (channelData.length == 0) {
            modalDialog.alertType("请至少选择一个发布渠道", "", "warning", "confirm");
            var html = $("html");
            var div = $(".dingweidiv")[0];
            html.animate({ scrollTop: html.scrollTop() + $(div).offset().top - html.offset().top }, 1000);
            return;
        }
        var d = $scope.list;
        var boo = ispub == 0 ? false : true;
        var params = {
            articleTitle: d.articleTitle,
            articleContent: d.articleHtmlCon,
            articleHtmlCon: d.articleHtmlCon,
            channels: JSON.stringify(channelData),
            articleType: '2',
            videos: JSON.stringify($scope.status.videoIds),
            articleWordsCount: d.DOCWORDSCOUNT,
            bPub: boo
        };
        //新建的时候不传id
        if (d.id != 0) {
            params.id = d.id
        }
        httpService.http("/mcnww/web/pgcArticle/saveOtherArticle.do", params, "post").then(function(data) {
            if (data && data.success) {
                var newId = data.id;
                $scope.list.id = newId;
                reFreshListPage();
                ueditorService.saveToLocal(newId);
                modalDialog.success((ispub ? "投稿" : "保存稿件") + "成功", "success", false, function() {
                    if (ispub) {
                        window.close();
                    }
                    $state.go("video", {
                        id: newId,
                        type: 5
                    }, {
                        reload: "video"
                    });
                }, function() {}, '', 'left0');
            }
        });
    }
    /**
     * [saveContent description] 保存正文
     * @return {[type]} [description]
     */
    function saveContent() {
        var deffer = $q.defer();
        ueditorService.saveContent($scope.list);
        if ($scope.list.articleHtmlCon === "") {
            $timeout(function() {
                //表单校验手动触发
                $scope.videoForm.content.$error.content = true;
                $scope.videoForm.content.$valid = false;
                $scope.videoForm.content.$invalid = true;
                $scope.videoForm.$error.content = [$scope.videoForm.content];
                $scope.videoForm.$valid = false;
                $scope.videoForm.$invalid = true;
                deffer.resolve();
            });
        } else {
            deffer.resolve();
        }
        return deffer.promise;
    }
    /**
     * [validator description] 表单校验
     * @return {[type]} [description]
     */
    function validator() {
        var deffer = $q.defer();
        $validation.validate($scope.videoForm).success(function() {
            deffer.resolve();
        }).error(function(result) {
            angular.invalidPosition($scope.videoForm, $element);
        });
        return deffer.promise;
    }
    /**
     * [getPubWayInfo description] 获取渠道
     * @return {[type]} [description]
     */
    function getPubWayInfo() {
        var deffer = $q.defer();
        httpService.http("/mcnww/web/channel/querySignChnlsAndTags.do", "", "get").then(function(data) {
            $scope.channels = data.channels;
            $scope.$broadcast('channels', $scope.channels);
            deffer.resolve();
        });
        return deffer.promise;
    }
    /**
     * [getSelectChannel description] 获取选取的渠道以及上传的图片
     * @return {[type]} [description]
     */
    function getSelectChannel() {
        var data = [];
        var channels = $scope.channels;
        for (var i = 0; i < channels.length; i++) {
            var _c = channels[i];
            if (_c.checked) {
                var o = {
                    channelId: _c.id, //渠道ID
                    channelName: _c.channelName, //渠道名称 
                    coverType: _c.coverType, //封面类型-单图 
                }
                var imgArr = [];
                if (_c.coverType == 0) {
                    imgArr[0] = _c.pic1;
                } else if (_c.coverType == 1) {
                    imgArr[0] = _c.pic1;
                    imgArr[1] = _c.pic2;
                    imgArr[2] = _c.pic3;
                }
                o.coverImg = imgArr; //封面图片数组
                data.push(o);
            }
        }
        return data;
    }
    /**
     * [reFreshList description] 刷新列表页
     * @return {[type]} [description]
     */
    function reFreshListPage() {
        localStorageService.set("refresh", Math.random());
    }
}]);
